import { autoPlayService, ErrorType, setErrorPopupData, useChipSetStore, usePlayerStore, useVoucherStore } from '@slot-nx/core'
import { useGameStore } from '../../game/store/GameStore'
import { GameState, MachineActionType, sweetBombMachine } from '../../../../machine/sweetbombMachine'

export const isPlayerHasEnoughBalance = (): boolean => {
  const balance = usePlayerStore.getState().balance
  const { isVoucherTime, isAnteBet } = useGameStore.getState()
  const { fixedStake } = useVoucherStore.getState()

  if (isVoucherTime) return true

  const stake = isVoucherTime ? fixedStake : useChipSetStore.getState().computed.currentStake
  const payStake = isAnteBet ? stake * 1.25 : stake
  return balance >= payStake
}

export const handleInsufficientBalance = (): void => {
  setErrorPopupData(ErrorType.InsufficientBalance, { enableReload: false })
  autoPlayService.cancel()
}

export const onSpin = (): void => {
  const currentState = sweetBombMachine.getSnapshot()
  const canPlaceOrder = currentState.matches(GameState.mainGame) || currentState.matches({ voucher: GameState.voucherTime })
  if (!canPlaceOrder) return

  if (!isPlayerHasEnoughBalance()) {
    handleInsufficientBalance()
    return
  }
  sweetBombMachine.send({ type: MachineActionType.placeOrder })
}
